/*
 * Public API Surface of ll-tabs
 */

export * from './lib/ll-tabs-core/ll-tabs-core.module';
export * from './lib/ll-tabs-core/ll-tabs.component';

export * from './lib/ll-decorated-tabs/ll-tabs.decorated.module';
export * from './lib/ll-decorated-tabs/ll-decorated-arrow.directive';
export * from './lib/ll-decorated-tabs/ll-decorated-panel.directive';
export * from './lib/ll-decorated-tabs/ll-decorated-tab.directive';
